import React, { useEffect } from 'react';
import { Main } from '@components/Main';
import { AboutUsContainer } from '@components/AboutUs';
import { withTrans } from '@i18n/withTrans';

const Index = ({ i18n, pageContext }) => {
  
  useEffect(() => {
    i18n.changeLanguage(pageContext.lang)
  }, [i18n, pageContext])
  
  return (
    <Main pageContext={pageContext}>
      <AboutUsContainer/>
    </Main>
  )
}

const IndexPage = withTrans(Index);

export default IndexPage 
